var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        {
          staticClass: "neu-cards-ctn landing-cnt  mt-5",
          attrs: { cols: "1", "cols-xl": "4" }
        },
        [
          _c("PatientPanelServiceBlock", {
            attrs: {
              id: "my-microhabits",
              visible: "",
              title: _vm.myMicrohabitsTitles[_vm.type],
              description: _vm.myMicrohabitsDescription[_vm.type],
              action: function() {
                return _vm.$router.push(
                  "/patient/" + _vm.microhabitTypeName + "/favorites"
                )
              },
              img:
                "/static-appopensalud/img/icons/morillas-svg-icons/primary/heart.svg",
              backgroundColor: _vm.GREEN_COLOUR,
              textAndIconColor: _vm.BLACK_COLOUR,
              only360Users: "",
              toggleableMobileDescription: false,
              hideArrowMobileButton: true
            },
            scopedSlots: _vm._u([
              {
                key: "footer",
                fn: function() {
                  return [
                    _c(
                      "span",
                      { staticClass: "d-block mt-3" },
                      [
                        _c(
                          "BBadge",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.bottom",
                                value: _vm.$t("patients.microhabits.selected"),
                                expression:
                                  "$t('patients.microhabits.selected')",
                                modifiers: { hover: true, bottom: true }
                              }
                            ],
                            attrs: { variant: "info" }
                          },
                          [_vm._v(_vm._s(_vm.favouritesNumber))]
                        ),
                        _vm._v(" "),
                        _c(
                          "BBadge",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.bottom",
                                value: _vm.$t("patients.microhabits.achieved"),
                                expression:
                                  "$t('patients.microhabits.achieved')",
                                modifiers: { hover: true, bottom: true }
                              }
                            ],
                            attrs: { variant: "primary" }
                          },
                          [_vm._v(_vm._s(_vm.achievedNumber))]
                        )
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _vm._l(_vm.categories, function(category) {
            return _c("PatientPanelServiceBlock", {
              key: category.id,
              attrs: {
                visible: "",
                id: category.id,
                title: _vm.$i18nHelpers.normalize(category.name),
                action: function() {
                  _vm.goToMicrohabits(category)
                },
                img: category.icon
              }
            })
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b66013aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b66013aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/microhabits/MicrohabitCategoriesPanelMenu.vue
// module id = 3107
// module chunks = 71 72